// extracted by mini-css-extract-plugin
export default {"container":"YoEml3Y3sN0ESxB8iBuz","visible":"mYGHNWvVdZmTX7xyW4gO","fullscreen":"yIEy6a24F4CtyG281tsD","score":"bKqeaZiydr6CTMwmO1TH"};